'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

var _Header = require('./components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Frame = require('./components/Frame');

var _Frame2 = _interopRequireDefault(_Frame);

var _Steps = require('./components/Steps');

var _Steps2 = _interopRequireDefault(_Steps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Prescription',
  computed: Object.assign({}, (0, _vuex.mapState)({
    showPrescriptionModule: function showPrescriptionModule(state) {
      return state.prescription.showPrescriptionModule;
    }
  }), {
    toggle: function toggle() {
      return document.getElementById('PrescriptionToggle');
    }
  }),
  components: {
    Header: _Header2.default,
    Frame: _Frame2.default,
    Steps: _Steps2.default
  },
  methods: Object.assign({}, (0, _vuex.mapMutations)(['showModule', 'hideModule']), {
    openListener: function openListener() {
      var _this = this;

      var url = document.getElementById('PrescriptionToggle').getAttribute('data-url');

      if (this.toggle) {
        this.toggle.addEventListener('click', function () {
          _this.showModule();
          setTimeout(function () {
            document.body.classList.add('customize-prescription-popup');
            if (!document.body.classList.contains('disable-top-bar')) {
              document.body.classList.add('temporary-disable-top-bar', 'disable-top-bar');
              document.querySelector('.js-top-bar').style.display = 'none';
            }
            document.querySelector('.product_route').setAttribute('value', url);
          }, 500);
        });
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.openListener();
    });
  }
};